const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_ENVIRONMENT = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;
const SENTRY_DEBUG = process.env.NEXT_PUBLIC_SENTRY_DEBUG;
const SENTRY_TRACE_SAMPLING_DEFAULT_RATE =
  process.env.NEXT_PUBLIC_SENTRY_TRACE_SAMPLING_DEFAULT_RATE;

export const ORGANIZATION = process.env.NEXT_PUBLIC_SENTRY_ORGANIZATION;
export const PROJECT = process.env.NEXT_PUBLIC_SENTRY_PROJECT;
export const AUTH_TOKEN = process.env.SENTRY_AUTH_TOKEN;
export const sentryConfig = {
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  debug: SENTRY_DEBUG === 'true',
  traceSamplingDefaultRate: SENTRY_TRACE_SAMPLING_DEFAULT_RATE
    ? parseFloat(SENTRY_TRACE_SAMPLING_DEFAULT_RATE)
    : 0,
};
